import { flatten } from "lodash";
import {
  CALCULATION_ADD_ROW,
  CALCULATION_COPY,
  CALCULATION_CREATE,
  CALCULATION_CREATE_OFFER,
  CALCULATION_DELETE,
  CALCULATION_DELETE_ROW,
  CALCULATION_ERROR,
  CALCULATION_FETCHING_DATA,
  CALCULATION_GET,
  CALCULATION_GET_ARTICLES,
  CALCULATION_GET_FOR_SELECTED_PROJECT,
  CALCULATION_GET_NORM_SETS,
  CALCULATION_INSERT_MEASUREMENT_STATE,
  CALCULATION_INSERT_ROWS,
  CALCULATION_SAVE,
  CALCULATION_SELECT_CALCULATION,
  CALCULATION_SET_DIRTY,
  CALCULATION_UPDATE,
  CALCULATION_UPDATE_CALCULATION_DATA,
  SET_ACTIVE_ARTICLE,
  SET_ACTIVE_LABOR,
  SET_ACTIVE_MEASUREMENT_STATE,
  SET_ACTIVE_NORMSET,
  SET_DATA_SELECTED_CALCULATION,
  UPDATE_ARTICLES,
  UPDATE_NORM_SETS,
} from "../../typesAction";
import { Calculation } from "./CalculationApi";
import { Calculator } from "./components/Grid/gridApiUtils";

declare type State = {
  data?: any;
  dataIsDirty: boolean;
  calculations_select: any;
  errorMessage?: any;
  inProgress: boolean;
  normSets: any;
  activeNormSet: any;
  articles: any;
  activeArticle: any;
  activeLabor: any;
  activeMeasurementState: any;
  selectedCalculationObj: Calculation;
  normSetsTotalItems: number;
  calculation_settings: any;
  sumTotalPrice: number;
  manDays: number;
  sumCostsTotal: number;
  totalVat: number;
  discount?: number;
  totalVatLow: number;
  totalVatHigh: number;
};

const INITIAL_STATE = {
  data: undefined,
  dataIsDirty: false,
  calculations_select: [],
  errorMessage: undefined,
  inProgress: false,
  normSets: [],
  activeNormSet: {},
  articles: [],
  activeArticle: {},
  activeLabor: {},
  activeMeasurementState: {},
  selectedCalculationObj: {},
  normSetsTotalItems: 0,
  calculation_settings: {},
  sumTotalPrice: 0,
  manDays: 0,
  sumCostsTotal: 0,
  totalVat: 0.0,
  discount: 0,
  totalVatLow: 0.0,
  totalVatHigh: 0.0,
};

const calculator = new Calculator();
function updateCalculationData(state: State, data: any) {
  const costGroups = state.selectedCalculationObj?.costGroups;
  // const costGroups = state.selectedCalculationObj?.costGroups?.filter(
  //   (cg: CostGroup) => !cg.excludeFromSurcharges
  // );

  return calculator.calculateFlatData(data, costGroups);
}

export default function (state: State = INITIAL_STATE, action: any): State {
  switch (action.type) {
    case CALCULATION_GET:
      return {
        ...state,
        data: action.payload,
        inProgress: false,
        errorMessage: null,
      };
    case CALCULATION_GET_FOR_SELECTED_PROJECT: {
      return {
        ...state,
        calculations_select: action.payload["hydra:member"].map((data: any) => {
          return {
            value: data.id,
            label: data.name,
            projectOffer: data.projectOffer,
          };
        }),
      };
    }

    case CALCULATION_CREATE_OFFER: {
      return {
        ...state,
        selectedCalculationObj: {
          ...state.selectedCalculationObj,
          projectOffer: action.payload,
        },
        calculations_select: state.calculations_select.map(
          (calculation: any) => {
            // if (calculation.value === state.selectedCalculationObj.value) {
            //   calculation.projectOffer = action.payload;
            // }

            return calculation;
          }
        ),
        inProgress: false,
        errorMessage: null,
      };
    }

    case CALCULATION_SAVE:
      return {
        ...state,
        selectedCalculationObj: action.payload,
        dataIsDirty: false,
        inProgress: false,
        errorMessage: null,
      };

    case CALCULATION_CREATE:
      return {
        ...state,
        calculations_select: [
          ...state.calculations_select,
          {
            value: action.payload.id,
            label: action.payload.name,
            data: action.payload.data,
          },
        ],
        inProgress: false,
        errorMessage: null,
      };

    case CALCULATION_COPY:
      return {
        ...state,
        calculations_select: [
          ...state.calculations_select,
          {
            value: action.payload.id,
            label: action.payload.name,
            data: action.payload.data,
          },
        ],
        inProgress: false,
        errorMessage: null,
      };

    case CALCULATION_DELETE:
      return {
        ...state,
        selectedCalculationObj: {},
        inProgress: false,
        errorMessage: null,
        sumTotalPrice: 0,
        manDays: 0,
        sumCostsTotal: 0,
        totalVat: 0.0,
        discount: undefined,
        totalVatLow: 0.0,
        totalVatHigh: 0.0,
      };
    case CALCULATION_FETCHING_DATA:
      return { ...state, inProgress: action.payload, errorMessage: null };
    case CALCULATION_ERROR:
      return {
        ...state,
        errorMessage: action.payload.data,
        inProgress: false,
      };
    case CALCULATION_ADD_ROW: {
      const { rowIndex, rowData } = action.payload;

      if (rowIndex < 0) {
        return {
          ...state,
          selectedCalculationObj: {
            ...state.selectedCalculationObj,
            data: [...state.selectedCalculationObj.data, rowData],
          },
        };
      }

      return {
        ...state,
        selectedCalculationObj: {
          ...state.selectedCalculationObj,
          data: [
            ...state.selectedCalculationObj?.data?.slice(0, rowIndex + 1),
            rowData,
            ...state.selectedCalculationObj?.data?.slice(rowIndex + 1),
          ],
        },
        dataIsDirty: true,
      };
    }

    case CALCULATION_DELETE_ROW: {
      const { parent, rowIndex } = action.payload;

      if (rowIndex >= 0) {
        let new_data: any = [];

        const calculation = state.selectedCalculationObj?.data;

        calculation.forEach((data: any) => {
          if (
            !data.typeHierarchy.filter(
              (typeHierarchy_obj: any) => typeHierarchy_obj === parent.id
            ).length
          ) {
            new_data.push(data);
          }
        });

        const calculationResult = updateCalculationData(state, new_data);
        return {
          ...state,
          selectedCalculationObj: {
            ...state.selectedCalculationObj,
            ...calculationResult,
          },
          dataIsDirty: true,
        } as State;
      }

      return { ...state };
    }
    case CALCULATION_GET_NORM_SETS: {
      return {
        ...state,
        normSets: action.payload["hydra:member"],
        normSetsTotalItems: action.payload["hydra:totalItems"],
      };
    }
    case UPDATE_NORM_SETS: {
      return {
        ...state,
        normSets: action.payload,
      };
    }
    case SET_ACTIVE_NORMSET: {
      return {
        ...state,
        activeNormSet: action.payload,
      };
    }
    case CALCULATION_INSERT_ROWS: {
      const { rowIndex, rowDatas } = action.payload;

      if (rowIndex === undefined) {
        const calculationResult = updateCalculationData(state, [
          ...state.selectedCalculationObj.data,
          ...flatten(rowDatas),
        ]);

        return {
          ...state,
          selectedCalculationObj: {
            ...state.selectedCalculationObj,
            ...calculationResult,
          },
        };
      }

      let calculationResult;
      try {
        calculationResult = updateCalculationData(state, [
          ...state.selectedCalculationObj.data.slice(0, rowIndex + 1),
          ...flatten(rowDatas),
          ...state.selectedCalculationObj.data.slice(rowIndex + 1),
        ]);
      } catch (err) {}

      return {
        ...state,
        selectedCalculationObj: {
          ...state.selectedCalculationObj,
          ...calculationResult,
        },
      };
    }
    case SET_DATA_SELECTED_CALCULATION: {
      return {
        ...state,
        selectedCalculationObj: {
          ...state.selectedCalculationObj,
          data: action.payload,
        },
      };
    }
    case CALCULATION_GET_ARTICLES: {
      return {
        ...state,
        articles: action.payload["hydra:member"],
      };
    }
    case UPDATE_ARTICLES: {
      return {
        ...state,
        articles: action.payload,
      };
    }
    case SET_ACTIVE_ARTICLE: {
      return {
        ...state,
        activeArticle: action.payload,
      };
    }
    case SET_ACTIVE_LABOR: {
      return {
        ...state,
        activeLabor: action.payload,
      };
    }
    case SET_ACTIVE_MEASUREMENT_STATE: {
      return {
        ...state,
        activeMeasurementState: action.payload,
      };
    }
    case CALCULATION_INSERT_MEASUREMENT_STATE: {
      const { rowIndex, rowData } = action.payload;
      const calculationResult = updateCalculationData(state, [
        ...state.selectedCalculationObj.data.slice(0, rowIndex),
        rowData,
        ...state.selectedCalculationObj.data.slice(rowIndex + 1),
      ]);

      return {
        ...state,
        selectedCalculationObj: {
          ...state.selectedCalculationObj,
          ...calculationResult,
        },
      };
    }

    case CALCULATION_SELECT_CALCULATION: {
      return {
        ...state,
        selectedCalculationObj: {
          ...state.selectedCalculationObj,
          ...action.payload,
        },
        dataIsDirty: false,
      };
    }

    case CALCULATION_SET_DIRTY: {
      return {
        ...state,
        dataIsDirty: action.payload,
      };
    }

    case CALCULATION_UPDATE: {
      const calculationResult = updateCalculationData(
        state,
        action.payload.data
      );

      return {
        ...state,
        selectedCalculationObj: {
          ...action.payload,
          ...calculationResult,
        },
        dataIsDirty: true,
      };
    }
    case CALCULATION_UPDATE_CALCULATION_DATA: {
      const calculationResult = updateCalculationData(
        state,
        action.payload.data
      );

      return {
        ...state,
        selectedCalculationObj: {
          ...state.selectedCalculationObj,
          ...calculationResult,
        },
        dataIsDirty: action.payload.isDirty,
      };
    }

    default:
      return state;
  }
}
